import React from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

export const ImageCropper = ({ image, setCroppedImage, profile }) => {
  return (
    <div style={{ width: '100%' }}>
      <Cropper
        style={{ height: 400, width: '100%' }}
        initialAspectRatio={profile ? 1 : 16 / 9}
        aspectRatio={profile ? 1 : 16 / 9}
        modal={false}
        src={image.temp}
        dragMode='none'
        viewMode={2}
        minCropBoxHeight={10}
        minCropBoxWidth={10}
        background={false}
        autoCropArea={1}
        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
        onInitialized={(instance) => {
          setCroppedImage(instance);
        }}
        guides={true}
      />
    </div>
  );
};
